import clsx from 'clsx'
import Link from 'next/link'
import s from './style.module.scss'
import {ReactNode, useState} from 'react'
import {LanguageCodes, languageCookieName} from '@app/i18n/settings'
import Cookies from 'js-cookie'
import triggerAnalytics from '@gamezop/analytics-sdk/client/trigger-analytics'

interface Props {
  url: string
  className?: string
  children: ReactNode
  selectedLanguage: string
  isActive: boolean
  currentLang: LanguageCodes
}

const LangLink = ({url, className, selectedLanguage, children, isActive, currentLang}: Props) => {
  const [isLoading, setLoading] = useState<boolean>(false)
  function setLangCookie(value: string) {
    Cookies.set(languageCookieName, value, {
      path: '/',
      expires: new Date(new Date().getTime() + 12 * 2629800000),
      secure: true,
      sameSite: 'lax',
    })
  }
  return (
    <Link
      href={url}
      prefetch={false}
      onClick={(e) => {
        if (isActive) {
          e.preventDefault()
        } else {
          setLoading(true)
          triggerAnalytics('lang-changed', {'selected-lang': selectedLanguage, 'current-lang': currentLang}).sendAll()
          setLangCookie(selectedLanguage)
        }
      }}
      className={clsx(className)}
    >
      {children}
      <span className={clsx('w-16 h-16', {[s.wave]: isLoading, hidden: !isLoading})} />
    </Link>
  )
}

export default LangLink
